<template>
  <div>
    <el-input-number
      class="b-input-number"
      controls-position="right"
      v-bind="$attrs"
      v-on="$listeners"
    >
    </el-input-number>
  </div>
</template>

<script>
export default {
  name: 'AdbInputNumber',
};
</script>

<style lang="scss" scoped>
.base {
  color: $shipber-text-color-text;
  width: 18px;
  background: transparent;
  border: none !important;
}

.posi {
  font-size: 20px;
  position: absolute;
  right: -5px;
  top: -18px;
}

.b-input-number {
  ::v-deep .el-input--small .el-input__inner {
    height: 36px !important;
    line-height: 36px !important;
    text-align: left;
  }
  ::v-deep .el-input-number__decrease {
    @extend .base;
  }
  ::v-deep .el-input-number__increase {
    @extend .base;
  }

  ::v-deep .el-input__inner {
    text-align: left;
  }

  ::v-deep .el-icon-arrow-down::before {
    content: '\e790';
    @extend .posi;
    top: -17px;
  }

  ::v-deep .el-icon-arrow-up::before {
    content: '\e78f';
    @extend .posi;
    top: -15px;
  }
}
</style>
